import { render } from "./setting.vue?vue&type=template&id=0b2580b1&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=0b2580b1&scoped=true&lang=css"
import "./setting.vue?vue&type=style&index=1&id=0b2580b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2580b1"]])

export default __exports__